import React from "react";
import "../styles/components/gtm-template-card.css";

const GTMTemplateCard = ({ icon, title, tags, description, downloadLink }) => {
  return (
    <div className="gtm-card">
      <div className="gtm-card-icon">{icon}</div>
      <h3 className="gtm-card-title">{title}</h3>
      <div className="gtm-card-tags">
        {tags.map((tag, i) => (
          <span key={i} className="gtm-card-tag">
            {tag}
          </span>
        ))}
      </div>
      <p className="gtm-card-description">{description}</p>
      <a href={downloadLink} download className="gtm-card-download">
        Last ned
      </a>
    </div>
  );
};

export default GTMTemplateCard;
